import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { trackEvent } from "@/lib/analytics";

export default function PagoExito() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [details, setDetails] = useState(null);
  const attempts = useRef(0);
  const tracked = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await apiClient.get(`/checkout/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") {
          if (!tracked.current) {
            tracked.current = true;
            trackEvent("purchase", {
              transaction_id: sessionId,
              value: data.amount_total ?? 0,
              currency: (data.currency || "USD").toUpperCase(),
              items: data.plan_id ? [{ item_id: data.plan_id, item_name: data.plan_id }] : [],
            });
          }
          setStatus("paid"); refresh(); return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        attempts.current += 1;
        if (attempts.current >= 8) { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch {
        attempts.current += 1;
        if (attempts.current >= 8) setStatus("error"); else setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div className="auth-card" data-testid="pago-exito-card">
        {status === "checking" && (<><i className="fas fa-spinner fa-spin" style={{ fontSize: 56, color: "#163680" }} /><h2>Verificando tu pago…</h2></>)}
        {status === "paid" && (<><i className="fas fa-check-circle" style={{ fontSize: 64, color: "#7DC242" }} /><h2>¡Pago Exitoso!</h2>
          <p>Tu membresía está <strong>activa</strong>. Ya puedes solicitar servicio.</p>
          {details?.amount_total != null && <p>Cobrado: ${details.amount_total.toFixed(2)} {details.currency?.toUpperCase()}</p>}</>)}
        {status === "expired" && (<><i className="fas fa-clock" style={{ fontSize: 56, color: "#E84C5E" }} /><h2>Sesión expirada</h2></>)}
        {status === "error" && (<><i className="fas fa-exclamation-triangle" style={{ fontSize: 56, color: "#E84C5E" }} /><h2>No pudimos confirmar el pago</h2></>)}
        <Link to="/cuenta" className="btn btn-primary" data-testid="pago-volver">Ir al dashboard</Link>
      </div>
    </div>
  );
}
